import React from 'react'
import { OneBlinkAppsError } from '@oneblink/apps-react'

import { getRequest } from '../lib/http'

import config from '../config'

interface State {
  isFetching: boolean
  fetchErrorMessage?: string
}

export default function useIsDraftInApprovals(): [
  state: State,
  fetchIsDraftInApprovals: (draftId: string) => Promise<boolean | undefined>,
] {
  const [state, setState] = React.useState<State>({ isFetching: false })

  const fetchIsDraftInApprovals = React.useCallback(async (draftId: string) => {
    let isDraftInApprovals = undefined
    try {
      setState({ isFetching: true })

      const { inApprovals } = await getRequest<{ inApprovals: boolean }>({
        url: `${config.HOSTED_API_URL}/drafts/is-draft-in-approvals?draftId=${draftId}`,
      })
      isDraftInApprovals = inApprovals

      setState({ isFetching: false })
    } catch (e) {
      const errorMessage =
        e instanceof Error || e instanceof OneBlinkAppsError
          ? e.message
          : typeof e === 'string'
            ? e
            : 'Failed to check if draft submitted'
      setState({ isFetching: false, fetchErrorMessage: errorMessage })
    } finally {
      return isDraftInApprovals
    }
  }, [])

  return [state, fetchIsDraftInApprovals]
}
